const INSTAGRAM_HANDLE = /^[A-Za-z0-9._]{1,30}$/
const LINKEDIN_SLUG = /^[A-Za-z0-9_%-]{3,100}$/

/** The Instagram handle in what someone typed (`@lena`, `lena`, a profile link), or null. */
export function instagramHandle(input: string): string | null {
  const trimmed = input.trim()
  const fromLink = trimmed.match(/instagram\.com\/([^/?#]+)/i)?.[1]
  const handle = (fromLink ?? trimmed).replace(/^@/, '')
  return INSTAGRAM_HANDLE.test(handle) ? handle : null
}

/** The LinkedIn profile address in what someone typed (a link or just the name part), or null. */
export function linkedinUrl(input: string): string | null {
  const trimmed = input.trim().replace(/\/+$/, '')
  const fromLink = trimmed.match(
    /^(?:https?:\/\/)?(?:[a-z]{2,3}\.)?linkedin\.com\/in\/([^/?#]+)/i,
  )?.[1]
  const slug = fromLink ?? (/[/.:]/.test(trimmed) ? null : trimmed)
  return slug && LINKEDIN_SLUG.test(slug) ? `https://www.linkedin.com/in/${slug}` : null
}

/** The name part of a LinkedIn profile address, to show as its label, or null. */
export function linkedinSlug(url: string): string | null {
  const slug = linkedinUrl(url)?.slice('https://www.linkedin.com/in/'.length)
  if (!slug) return null
  try {
    return decodeURIComponent(slug)
  } catch {
    return slug
  }
}
